import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "file"];
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Video = _ref => {
  var {
    file
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_jsxs("video", _extends({
    className: "w-full aspect-video",
    controls: true
  }, rest, {
    children: [/*#__PURE__*/_jsx("source", {
      src: file == null ? void 0 : file.filename
    }), "Your browser does not support the video tag."]
  }));
};
//# sourceMappingURL=video.js.map